/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { LicensePlate, SamlToken } from 'client-code/device-binding-service';
import { DeviceBindingServiceRepositoryImpl } from '../impls/DeviceBindingServiceRepositoryImpl';
import { IDeviceBindingServiceRepository } from '../interfaces/IDeviceBindingService';

export class DeviceBindingService implements IDeviceBindingServiceRepository {
    private oDeviceBindingServiceRepositoryImpl: DeviceBindingServiceRepositoryImpl;

    constructor() {
        this.oDeviceBindingServiceRepositoryImpl = new DeviceBindingServiceRepositoryImpl();
    }

    static initialize(baseUrl: string) {
        DeviceBindingServiceRepositoryImpl.initialize(baseUrl);
    }

    fetchLicensePlate(newLicensePlate: boolean): Promise<LicensePlate> {
        return this.oDeviceBindingServiceRepositoryImpl.fetchLicensePlate(newLicensePlate);
    }

    fetchSamlToken(licensePlateCode?: string): Promise<SamlToken> {
        return this.oDeviceBindingServiceRepositoryImpl.fetchSamlToken(licensePlateCode);
    }

    removeDeviceBinding(): Promise<void> {
        return this.oDeviceBindingServiceRepositoryImpl.removeDeviceBinding();
    }
}
